import React, { useEffect, useMemo, useState } from "react";
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from './style.module.scss'
import { useBot, useQuery } from "../../../../../../../hooks/common";
import { getLowerPrice, getDelPrice, unitPrice, getLowerPriceWithVariant, getDelPriceWithVariant, getAddOnLowerPrice, getAddOnDelPrice, getPrices } from "../../../../../../../../utils/product";
import { FormattedMessage } from "react-intl";
import ProductStarScore from "../../../../module/product-star-score/index";
import ProductPromotionContain from "../promotion-contain";
import { Iconfont } from "../../../../../../../components/icon/iconfont";
import CountDown from "../../../../../../../components/count-down";
import { useSelector } from "react-redux";
import KlarnaMessage from '../klarna-message'
// import PaypalMessage from '../../../../../../../components/paypal-message'
import deeplink from "../../../../../../../../utils/deeplink";
import { getSensorsUrl } from "../../../../../../../utils/sensor";
import Mask from "../../../../../../components/mask"
import PayMessages from "../../../../../../../components/pay-messages"
import PriceDiscountAlert, { DiscountAlert } from "../price-discount-alert";


// const offerAfterWedgit = (onload) => {
//     const afterScript = document.getElementById('after-wedgit-script')
//     if (!afterScript) {
//         const head = document.getElementsByTagName('head')[0]
//         const script = document.createElement('script')
//         script.type = 'text/javascript'
//         script.id = 'after-wedgit-script'
//         script.defer = true
//         script.async = true
//         script.src = "https://portal.afterpay.com/afterpay.js"
//         script.onload = onload
//         head.appendChild(script)
//     } else {
//         onload()
//     }
// }

const FlashSaleCountDown = props => {
    const { promotion, serverTime } = props;

    const showCountDown = useMemo(() => {
        let { startTime, endTime } = promotion;
        if ((startTime < serverTime) && (endTime > serverTime)) {
            return true;
        } else {
            return false;
        }
    }, [promotion])

    const handleClick = () => {
        if (promotion?.deepLink) {
            let href = deeplink(promotion?.deepLink, "pc");

            window.location.href = getSensorsUrl(href, {
                resourcepage_title: 'product',
                resource_position: "1",
                resource_type: '2',
                resource_content: promotion?.description
            })
        }
    }

    return <div className={`${classes.FLashSalePromotion}`} onClick={handleClick}>
        <span className={classes.Item}>
            <Iconfont style={{ fontSize: 14 }}>&#xe624;</Iconfont>
            <span className={classes.Font}>{promotion?.subTitle} </span>

            {
                showCountDown && <CountDown
                    style={{ fontSize: 14, lineHeight: '16px', float: 'right' }}
                    offset={promotion?.endTime - serverTime}
                    showDay
                    showHour
                    showLabel
                    dotStyle={{ padding: "0px 4px" }}
                />
            }


        </span>
    </div>
}

const StagingMask = props => {
    useStyles(classes)
    const { href, lower, onClose } = props
    let frameHref = href
    let reg = /^\//
    if (!reg.test(frameHref)) {
        frameHref = '/' + frameHref
    }
    if (href?.indexOf('?') != -1) {
        frameHref += '&isApp=1&total=' + lower
    } else {
        frameHref += '?isApp=1&total=' + lower
    }
    return <React.Fragment>
        <Mask onClick={() => onClose()} />
        <div className={classes.stagingMask}>
            <Iconfont className={classes.stagingClose} onClick={() => onClose()}>&#xe7c9;</Iconfont>
            <iframe src={frameHref} frameborder="0"></iframe>
        </div>
    </React.Fragment>
}

const StagingInfoBox = props => {
    useStyles(classes)
    const { instalments, lower } = props
    const [showMask, setShowMask] = useState(false)
    return <div className={classes.stagingBox}>
        {
            instalments?.icon &&
            <img src={instalments?.icon} alt="" />
        }
        {
            instalments?.text && instalments?.href &&
            <span onClick={() => setShowMask(true)}>{instalments?.text}</span>
        }

        {
            showMask &&
            <StagingMask href={instalments?.href} lower={lower} onClose={() => setShowMask(false)} />
        }
    </div>
}


const BasicInformation = props => {
    useStyles(classes);
    const { selectedProduct, reviewItem, promotionFlash, serverTime, productVO, selectedVariant, showProm, setShowProm, estimatedPercent } = props;
    const query = useQuery();
    const isAddOn = query?.product_type == 'addOn'
    const isGift = query?.product_type == 'gift'

    const isEstimated = selectedProduct?.estimatedPrice && !isAddOn && !isGift

    const lower = selectedVariant && !isAddOn ?
        getLowerPriceWithVariant(selectedVariant) :
        isAddOn ?
            getAddOnLowerPrice(selectedProduct) :
            getLowerPrice(selectedProduct)
    const higher = selectedVariant && !isAddOn ?
        getDelPriceWithVariant(selectedVariant) :
        isAddOn ?
            getAddOnDelPrice(selectedProduct) :
            getDelPrice(selectedProduct)


    const pageProduct = useSelector(state => state.pageProduct)
    const { couponActivity } = productVO
    const { instalments } = productVO?.products?.[0] || {}
    const global = useSelector(state => state.global)
    const isBot = useBot()

    if (query?.product_type == 'gift') {
        lower.amount = "0.00"
    }

    let off = 0;
    if (higher) {
        off = Math.round((Number(higher.amount) - Number(lower.amount)) * 100 / Number(higher.amount));
    }


    // useEffect(async () => {
    //     if (pageProduct?.clearpay && global.currency === 'GBP') {
    //         offerAfterWedgit(() => {
    //             new window.AfterPay.Widgets.Placement({
    //                 target: "#afterpay-messaging-widget",
    //                 locale: "en-GB",
    //                 context: "CHECKOUT",
    //                 publicKey: pageProduct?.clearpay,
    //                 attributes: {
    //                     amount: lower.amount,
    //                     promoRenderStyle: "promo-only",
    //                     size: "sm"
    //                 }
    //             })
    //         })
    //     }
    // }, [])

    let prices = []
    if (selectedProduct?.variants) {
        prices = getPrices(selectedProduct?.variants)
    }

    const shouldShowPrices = prices.length > 1 && !isAddOn && !isGift && !selectedVariant

    return <div className={classes.BasicInformation}>
        <div className={classes.NameAndIcon}>
            {
                selectedProduct?.icon1 && <div className={classes.Icon}>
                    <img src={selectedProduct?.icon1} alt="Icon1" />
                </div>
            }

            <div>
                <h1 className={classes.ProductName}>
                    {
                        selectedProduct?.flag && <span className={`${classes.New} ${classes.PreFall}`}>{selectedProduct?.flag}</span>
                    }
                    {
                        !selectedProduct?.flag && selectedProduct?.isNew && !selectedProduct?.isPreOrder && <span className={classes.New}><FormattedMessage id="new" defaultMessage="NEW" /></span>
                    }

                    {
                        selectedProduct?.isPreOrder && <span className={classes.PreOrderFlag}>Pre order</span>
                    }

                    <span>
                        {
                            query?.geeko_ads ? (selectedProduct?.adName ?? selectedProduct?.name) : (selectedProduct?.name)
                        }
                    </span>
                </h1>

                {
                    selectedProduct.parentSku && <p className={classes.ProductSku}><span><span style={{ textTransform: "uppercase" }}>Sku</span>: {selectedProduct.parentSku}</span></p>
                }
            </div>
        </div>




        {
            reviewItem?.total > 0 && <div className={classes.ReviewTitles}>
                <span className={classes.ReviewAvg}>{reviewItem?.avgScore.toFixed(1)}</span>
                <ProductStarScore starScore={reviewItem?.avgScore} />
                <a className={classes.Reviews} href="#commentbox"><span>{reviewItem.total} <FormattedMessage id="reviews" defaultMessage="Reviews" />&gt; </span></a>
            </div>
        }

        <div className={classes.ProductPricesContainer}>

            {
                shouldShowPrices ? <div className={classes.PricesItem}>
                    <span className={classes.LowerPrice} style={{ color: (higher ? "#e64545" : "#222") }}>
                        {unitPrice(prices[0])}-{unitPrice(prices[1])}
                    </span>
                </div> : <div className={classes.PricesItem}>
                    <span className={classes.LowerPrice} style={{ color: (higher ? "#e64545" : "#222") }}>
                        {
                            query?.product_type && selectedProduct?.giftPrice ?
                                (unitPrice(selectedProduct?.giftPrice) || '-') :
                                (unitPrice(lower) || '-')
                        }
                    </span>

                    {
                        isEstimated &&
                        <PriceDiscountAlert
                            showProm={showProm}
                            setShowProm={setShowProm}
                            selectedVariant={selectedVariant}
                            selectedProduct={selectedProduct}
                            per={estimatedPercent}
                            amount={selectedProduct?.estimatedPrice}
                        />
                    }

                    {
                        query?.product_type != 'gift' && <React.Fragment>
                            {
                                higher && <del className={classes.DelPrice}>{unitPrice(higher)}</del>
                            }
                            {
                                off > 0 && <span className={classes.DiscountOff}>{`-${off}%`}</span>
                            }
                        </React.Fragment>
                    }

                    {
                        isEstimated && <Iconfont className={classes.toPageIcon} onClick={() => {
                            if (window.GeekoSensors) {
                                window.GeekoSensors.Track('ELClick', {
                                    clicks: "estimated_price",
                                })
                            }
                            setShowProm(true)
                        }}>&#xe694;</Iconfont>
                    }
                </div>
            }



            {/* {
                selectedProduct?.promotion?.enabled && !selectedProduct?.promotion?.countdownHidden && <ProductPromotionContain promotion={selectedProduct.promotion} />
            } */}
        </div>
        {
            instalments &&
            <StagingInfoBox instalments={instalments} lower={lower?.amount} />
        }


        {/* {
            pageProduct.clearpay && !isBot && <div id="afterpay-messaging-widget"></div>
        }


        {
            !isBot && selectedProduct?.price?.currency === 'USD' && <KlarnaMessage amount={lower?.amount}/>
        }

        {
            global?.config?.paypal?.showMessage && <PaypalMessage money={lower} country={global.country} clientId={global?.config?.paypal?.clientId}/>
        } */}


        {
            global?.config?.showPayMessage ? <div style={{ marginTop: 8 }}>
                <PayMessages customerPayMethod={productVO?.payMethod} money={lower} />
            </div> : <>
                {
                    !isBot && selectedProduct?.price?.currency === 'USD' && <KlarnaMessage amount={lower?.amount} />
                }
            </>
        }

        {
            promotionFlash && <>
                <FlashSaleCountDown promotion={promotionFlash} serverTime={serverTime} />
            </>
        }

        {
            showProm &&
            <DiscountAlert
                selectedProduct={selectedProduct}
                selectedVariant={selectedVariant}
                isEstimated={isEstimated}
                show={showProm}
                setShow={setShowProm}
                couponActivity={couponActivity}
                originPrice={getAddOnDelPrice(selectedProduct)}
                per={estimatedPercent}
                lower={lower}
            />
        }

    </div>
}

export default BasicInformation;